'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _antd = require('antd');

var _GenericField = require('./GenericField');

var _GenericField2 = _interopRequireDefault(_GenericField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UrlField = function (_React$Component) {
	_inherits(UrlField, _React$Component);

	function UrlField() {
		_classCallCheck(this, UrlField);

		return _possibleConstructorReturn(this, (UrlField.__proto__ || Object.getPrototypeOf(UrlField)).apply(this, arguments));
	}

	_createClass(UrlField, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    form = _props.form,
			    onChangeFormField = _props.onChangeFormField,
			    index = _props.index,
			    errorField = _props.errorField;
			var isExternal = form.isExternal;

			return _react2.default.createElement(
				_GenericField2.default,
				this.props,
				_react2.default.createElement(
					_antd.Col,
					{ md: { span: 3, offset: 1 }, sm: 23, style: { display: 'flex', justifyContent: 'center' } },
					_react2.default.createElement(
						_antd.Form.Item,
						{
							validateStatus: errorField === 'isExternal' ? 'error' : 'success',
							help: errorField === 'isExternal' ? 'Valor inválido' : ''
						},
						_react2.default.createElement(
							_antd.Checkbox,
							{
								checked: isExternal,
								onChange: function onChange(e) {
									return onChangeFormField('isExternal', index, e.target.checked);
								}
							},
							'Abrir fora do Aplicativo'
						)
					)
				)
			);
		}
	}]);

	return UrlField;
}(_react2.default.Component);

exports.default = UrlField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9nZW5lcmljTWF0ZXJpYWxBcmVhcy9Db250ZW50VHJlZS9mb3JtVHlwZXMvVXJsRmllbGQuanMiXSwibmFtZXMiOlsiVXJsRmllbGQiLCJwcm9wcyIsImZvcm0iLCJvbkNoYW5nZUZvcm1GaWVsZCIsImluZGV4IiwiZXJyb3JGaWVsZCIsImlzRXh0ZXJuYWwiLCJzcGFuIiwib2Zmc2V0IiwiZGlzcGxheSIsImp1c3RpZnlDb250ZW50IiwiZSIsInRhcmdldCIsImNoZWNrZWQiLCJSZWFjdCIsIkNvbXBvbmVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUNBOztBQUNBOzs7Ozs7Ozs7Ozs7SUFFcUJBLFE7Ozs7Ozs7Ozs7OzJCQUVYO0FBQUEsZ0JBQytDLEtBQUtDLEtBRHBEO0FBQUEsT0FDQUMsSUFEQSxVQUNBQSxJQURBO0FBQUEsT0FDTUMsaUJBRE4sVUFDTUEsaUJBRE47QUFBQSxPQUN5QkMsS0FEekIsVUFDeUJBLEtBRHpCO0FBQUEsT0FDZ0NDLFVBRGhDLFVBQ2dDQSxVQURoQztBQUFBLE9BRUFDLFVBRkEsR0FFZUosSUFGZixDQUVBSSxVQUZBOztBQUdSLFVBQ0M7QUFBQywwQkFBRDtBQUFrQixTQUFLTCxLQUF2QjtBQUNDO0FBQUMsY0FBRDtBQUFBLE9BQUssSUFBSSxFQUFFTSxNQUFNLENBQVIsRUFBV0MsUUFBUSxDQUFuQixFQUFULEVBQWlDLElBQUksRUFBckMsRUFBeUMsT0FBTyxFQUFFQyxTQUFTLE1BQVgsRUFBbUJDLGdCQUFnQixRQUFuQyxFQUFoRDtBQUNDO0FBQUMsZ0JBQUQsQ0FBTSxJQUFOO0FBQUE7QUFDQyx1QkFBZ0JMLGVBQWUsWUFBZixHQUE4QixPQUE5QixHQUF3QyxTQUR6RDtBQUVDLGFBQU1BLGVBQWUsWUFBZixHQUE4QixnQkFBOUIsR0FBaUQ7QUFGeEQ7QUFJQztBQUFDLHFCQUFEO0FBQUE7QUFDQyxpQkFBU0MsVUFEVjtBQUVDLGtCQUFVLGtCQUFDSyxDQUFEO0FBQUEsZ0JBQU9SLGtCQUFrQixZQUFsQixFQUFnQ0MsS0FBaEMsRUFBdUNPLEVBQUVDLE1BQUYsQ0FBU0MsT0FBaEQsQ0FBUDtBQUFBO0FBRlg7QUFBQTtBQUFBO0FBSkQ7QUFERDtBQURELElBREQ7QUFpQkE7Ozs7RUF0Qm9DQyxnQkFBTUMsUzs7a0JBQXZCZixRIiwiZmlsZSI6IlVybEZpZWxkLmpzIiwic291cmNlUm9vdCI6Ii9zcmMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgQ2hlY2tib3gsIENvbCwgRm9ybSB9IGZyb20gJ2FudGQnO1xuaW1wb3J0IEdlbmVyaWNGaWVsZCBmcm9tICcuL0dlbmVyaWNGaWVsZCc7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFVybEZpZWxkIGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50IHtcblx0XG5cdHJlbmRlcigpIHtcblx0XHRjb25zdCB7IGZvcm0sIG9uQ2hhbmdlRm9ybUZpZWxkLCBpbmRleCwgZXJyb3JGaWVsZCB9ID0gdGhpcy5wcm9wcztcblx0XHRjb25zdCB7IGlzRXh0ZXJuYWwgfSA9IGZvcm07XG5cdFx0cmV0dXJuIChcblx0XHRcdDxHZW5lcmljRmllbGQgey4uLnRoaXMucHJvcHN9PlxuXHRcdFx0XHQ8Q29sIG1kPXt7IHNwYW46IDMsIG9mZnNldDogMSB9fSBzbT17MjN9IHN0eWxlPXt7IGRpc3BsYXk6ICdmbGV4JywganVzdGlmeUNvbnRlbnQ6ICdjZW50ZXInIH19PlxuXHRcdFx0XHRcdDxGb3JtLkl0ZW1cblx0XHRcdFx0XHRcdHZhbGlkYXRlU3RhdHVzPXtlcnJvckZpZWxkID09PSAnaXNFeHRlcm5hbCcgPyAnZXJyb3InIDogJ3N1Y2Nlc3MnfVxuXHRcdFx0XHRcdFx0aGVscD17ZXJyb3JGaWVsZCA9PT0gJ2lzRXh0ZXJuYWwnID8gJ1ZhbG9yIGludsOhbGlkbycgOiAnJ31cblx0XHRcdFx0XHQ+XG5cdFx0XHRcdFx0XHQ8Q2hlY2tib3hcblx0XHRcdFx0XHRcdFx0Y2hlY2tlZD17aXNFeHRlcm5hbH1cblx0XHRcdFx0XHRcdFx0b25DaGFuZ2U9eyhlKSA9PiBvbkNoYW5nZUZvcm1GaWVsZCgnaXNFeHRlcm5hbCcsIGluZGV4LCBlLnRhcmdldC5jaGVja2VkKX1cblx0XHRcdFx0XHRcdD5cblx0XHRcdFx0XHRcdFx0QWJyaXIgZm9yYSBkbyBBcGxpY2F0aXZvXG5cdFx0XHRcdFx0XHQ8L0NoZWNrYm94PlxuXHRcdFx0XHRcdDwvRm9ybS5JdGVtPlxuXHRcdFx0XHQ8L0NvbD5cblx0XHRcdDwvR2VuZXJpY0ZpZWxkPlxuXHRcdCk7XG5cdH1cbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/client/components/genericMaterialAreas/ContentTree/formTypes/UrlField.js
// module id = 3231
// module chunks = 0